<div class="diagram">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505 542">
    <g
      id="Pickup_truck_double_cabin"
      data-name="Pickup truck  double cabin"
      transform="translate(-445 -115)"
    >
      <text
        id="Pickup_truck_double_cabin-2"
        data-name="Pickup truck double cabin"
        transform="translate(699 128)"
        fill="#242e3a"
        font-size="14"
        font-family="Roboto-Bold, Roboto"
        font-weight="700"
      >
        <tspan x="-42.868" y="0">Truck Double Cabin</tspan>
      </text>
      <g id="Rest_Elements" data-name="Rest Elements">
        <g
          id="Group_1021"
          data-name="Group 1021"
          transform="translate(427.193 776.986) rotate(-90)"
        >
          <path
            id="Path_710"
            data-name="Path 710"
            d="M1153.4,350.244V391.83l5.93-8.127V355.443Z"
            transform="translate(-582.983 -91.917)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_711"
            data-name="Path 711"
            d="M1150.679,329.9l1.1,8.2v41.586l-.549,7.028,5.015-7.028a29.227,29.227,0,0,0,1.464-8.127V343.3s-1.318-7.688-2.05-8.42Z"
            transform="translate(-581.357 -79.775)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <g id="Group_1017" data-name="Group 1017" transform="translate(547.083 213.649)">
            <path
              id="Path_714"
              data-name="Path 714"
              d="M1137.988,292.27c.072.172,6.434,3.016,6.434,3.016a76.977,76.977,0,0,1,3.661,17.132l-2.819-2.819-2.709-13.05-3.492-1.668Z"
              transform="translate(-1120.865 -270.961)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
          </g>
          <g id="Group_1018" data-name="Group 1018" transform="translate(547.083 299.61)">
            <path
              id="Path_716"
              data-name="Path 716"
              d="M1146.857,455.063l-4.064,15.029-4.238,1.73-1.088,2.633,6.888-3.021s3.178-10.3,3.417-16.638a4.839,4.839,0,0,0,.812-2.139"
              transform="translate(-1120.554 -452.657)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
          </g>
          <path
            id="Path_720"
            data-name="Path 720"
            d="M970.87,284.5s59.523,10.762,70.286,16.693"
            transform="translate(-474.03 -52.672)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_721"
            data-name="Path 721"
            d="M970.87,491s59.523-10.763,70.286-16.693"
            transform="translate(-474.03 -165.971)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_725"
            data-name="Path 725"
            d="M916.019,273.235s5.308,12.776,5.308,51.213c0,0-1.5,47.04-5.308,51.433"
            transform="translate(-441.289 -45.95)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_730"
            data-name="Path 730"
            d="M699.25,534.283l1.867,8.566s.439,2.965,2.526,2.965,70.8-.256,70.8-.256,2.672.037.769-2.343-33.678-11.055-42.976-11.055-28.846-.659-28.846-.659S699.945,531.281,699.25,534.283Z"
            transform="translate(-311.901 -200.106)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_732"
            data-name="Path 732"
            d="M682.979,571.282s.293,1.281-1.318,1.684-7.724,1.977-7.724,1.977H525.057s-.842-.073-.805-.659,0-1.94,0-1.94Z"
            transform="translate(-207.444 -223.854)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_733"
            data-name="Path 733"
            d="M695.231,569.33c.137.027,7.33.137,7.33.137l.467.769h6.315l.851-.906h5.079l-3.487,2.617-13.481-.146Z"
            transform="translate(-309.502 -222.688)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_736"
            data-name="Path 736"
            d="M543.911,533.954v8.383s-.842,2.343,5.967,2.965,46.2.842,46.2.842a2.041,2.041,0,0,0,2.05-1.9c.147-1.9-1.244-8.859-1.244-8.859a5.052,5.052,0,0,0-4.832-3.884c-2.447,0-18.92.113-31.117.2l-13.4.1S544.314,531.428,543.911,533.954Z"
            transform="translate(-219.16 -200.107)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_738"
            data-name="Path 738"
            d="M532.132,569.33c.137.027,7.33.137,7.33.137l.467.769h6.315l.851-.906h5.079l-3.486,2.617-13.481-.146Z"
            transform="translate(-212.149 -222.688)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_739"
            data-name="Path 739"
            d="M586.185,531.994l1.429,14.117h2.855l-1.208-14.117Z"
            transform="translate(-244.412 -200.403)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_740"
            data-name="Path 740"
            d="M598.146,554.731s-42.977.8-45.173-1.611c0,0-2.2,3.954,13.324,4.027s28.481,0,28.481,0S599.318,556.634,598.146,554.731Z"
            transform="translate(-224.525 -213.013)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_741"
            data-name="Path 741"
            d="M661.594,531.968l1.125,9.248a3.634,3.634,0,0,1-3.88,3.327h4.524s1.626.114,1.626-2.448-.667-8.694-.667-8.694S662.189,531.762,661.594,531.968Z"
            transform="translate(-287.779 -200.376)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_742"
            data-name="Path 742"
            d="M551.259,532.468a3.366,3.366,0,0,0-2.2,3.258v5.6s-.125,1.858,4.733,2.723c0,0-6.82.091-6.747-2.67a41.38,41.38,0,0,0-.183-5.068v-.439l.4-.073.037-2.16S546.573,531.993,551.259,532.468Z"
            transform="translate(-220.943 -200.634)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_743"
            data-name="Path 743"
            d="M703.264,532.874s2.416,11.48,4.5,11.286,58,0,58,0l-1.019-2.61-54.3.6s-.815.716-1.8-1.481-2.892-9.262-2.892-9.262S702.8,530.873,703.264,532.874Z"
            transform="translate(-314.267 -200.015)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_744"
            data-name="Path 744"
            d="M712.6,544.061a12.93,12.93,0,0,0,3.734,1.089H768"
            transform="translate(-319.869 -207.605)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_745"
            data-name="Path 745"
            d="M752.659,532.885v5.594h-5.051v-5.594Z"
            transform="translate(-340.765 -200.935)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <line
            id="Line_46"
            data-name="Line 46"
            x1="4.612"
            y2="0.11"
            transform="translate(406.842 333.628)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_746"
            data-name="Path 746"
            d="M505.932,535.254h-2.983s-1.647.22-1.647-1.263V531.85l-1.977-1.7v2.141l-3.926-3.926v-6.232l3.157-6.974v-4.008h-.522v-.3l.138.3h11.2v-.6l108.008,1.887,2.384.042-1.964-.034s-.688,3.158-1.378,3.158l-33.471-.86s-3.15-.031-3.369,1.669"
            transform="translate(-190.222 -187.075)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_747"
            data-name="Path 747"
            d="M846.8,538.6s-39.217-13.288-51.164-14.221"
            transform="translate(-369.431 -195.857)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_748"
            data-name="Path 748"
            d="M511.9,514.252V521.2h5.711"
            transform="translate(-200.074 -189.813)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_749"
            data-name="Path 749"
            d="M503.23,516.976v10.836h8.308"
            transform="translate(-194.897 -191.439)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_750"
            data-name="Path 750"
            d="M699.25,245.1l1.867-8.566s.439-2.965,2.526-2.965,70.8.256,70.8.256,2.672-.037.769,2.343-33.678,11.056-42.976,11.056-28.846.659-28.846.659S699.945,248.1,699.25,245.1Z"
            transform="translate(-311.901 -22.274)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_753"
            data-name="Path 753"
            d="M695.231,227.377c.137-.027,7.33-.137,7.33-.137l.467-.769h6.315l.851.906h5.079l-3.487-2.617-13.481.146Z"
            transform="translate(-309.502 -17.016)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_756"
            data-name="Path 756"
            d="M543.911,244.941v-8.383s-.842-2.343,5.967-2.965,46.2-.842,46.2-.842a2.041,2.041,0,0,1,2.05,1.9c.147,1.9-1.244,8.859-1.244,8.859a5.052,5.052,0,0,1-4.832,3.884c-2.447,0-18.92-.114-31.117-.2l-13.4-.1S544.314,247.467,543.911,244.941Z"
            transform="translate(-219.16 -21.786)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_758"
            data-name="Path 758"
            d="M532.132,227.377c.137-.027,7.33-.137,7.33-.137l.467-.769h6.315l.851.906h5.079l-3.486-2.617-13.481.146Z"
            transform="translate(-212.149 -17.016)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_759"
            data-name="Path 759"
            d="M586.185,247.685l1.429-14.117h2.855l-1.208,14.117Z"
            transform="translate(-244.412 -22.274)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_760"
            data-name="Path 760"
            d="M598.146,239.842s-42.977-.805-45.173,1.611c0,0-2.2-3.954,13.324-4.027s28.481,0,28.481,0S599.318,237.938,598.146,239.842Z"
            transform="translate(-224.525 -24.556)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_761"
            data-name="Path 761"
            d="M661.594,249.967l1.125-9.248a3.634,3.634,0,0,0-3.88-3.327h4.524s1.626-.114,1.626,2.448-.667,8.694-.667,8.694S662.189,250.173,661.594,249.967Z"
            transform="translate(-287.779 -24.555)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_762"
            data-name="Path 762"
            d="M551.259,250.836a3.366,3.366,0,0,1-2.2-3.258v-5.6s-.125-1.859,4.733-2.723c0,0-6.82-.092-6.747,2.67a41.37,41.37,0,0,1-.183,5.068v.439l.4.073.037,2.16S546.573,251.312,551.259,250.836Z"
            transform="translate(-220.943 -25.667)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_763"
            data-name="Path 763"
            d="M703.264,248.728s2.416-11.48,4.5-11.286,58,0,58,0l-1.019,2.61-54.3-.6s-.815-.716-1.8,1.481-2.892,9.261-2.892,9.261S702.8,250.729,703.264,248.728Z"
            transform="translate(-314.267 -24.584)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_764"
            data-name="Path 764"
            d="M712.6,254.909a12.931,12.931,0,0,1,3.734-1.089H768"
            transform="translate(-319.869 -34.362)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_765"
            data-name="Path 765"
            d="M752.659,259.414V253.82h-5.051v5.594Z"
            transform="translate(-340.765 -34.361)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <line
            id="Line_47"
            data-name="Line 47"
            x1="4.612"
            y1="0.11"
            transform="translate(406.842 223.266)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_766"
            data-name="Path 766"
            d="M505.932,227.422h-2.983s-1.647-.22-1.647,1.263v2.141l-1.977,1.7v-2.141l-3.926,3.926v6.232l3.157,6.974v4.008h-.522v.3l.138-.3h11.2v.6l108.008-1.887,2.384-.042-1.964.035s-.688-3.158-1.378-3.158l-33.471.86s-3.15.031-3.369-1.668"
            transform="translate(-190.222 -18.598)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_767"
            data-name="Path 767"
            d="M846.8,240.924s-39.217,13.288-51.164,14.222"
            transform="translate(-369.431 -26.664)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_768"
            data-name="Path 768"
            d="M511.9,276.037v-6.952h5.711"
            transform="translate(-200.074 -43.473)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_769"
            data-name="Path 769"
            d="M503.23,267.561V256.726h8.308"
            transform="translate(-194.897 -36.096)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <g id="Group_1019" data-name="Group 1019" transform="translate(227.633 346.916)">
            <path
              id="Path_772"
              data-name="Path 772"
              d="M458.726,570.438v1.757s.051.964.508.964,9.008,1.193,14.616-2.842Z"
              transform="translate(-395.966 -570.194)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
          </g>
          <g id="Group_1020" data-name="Group 1020" transform="translate(227.633 205.182)">
            <path
              id="Path_774"
              data-name="Path 774"
              d="M458.726,225.693v-1.757s.051-.964.508-.964,9.008-1.193,14.616,2.842Z"
              transform="translate(-395.966 -221.032)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
          </g>
          <path
            id="Path_776"
            data-name="Path 776"
            d="M320.331,240.632H204.43s-4.832-1.395-4.832,4.975"
            transform="translate(-13.66 -26.413)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_777"
            data-name="Path 777"
            d="M320.331,551.764H204.43s-4.832,1.395-4.832-4.975"
            transform="translate(-13.66 -209.234)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <line
            id="Line_48"
            data-name="Line 48"
            y2="127.917"
            transform="translate(190.77 214.22)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_778"
            data-name="Path 778"
            d="M201.233,235.457a25.811,25.811,0,0,1,1.537,3.734,25.041,25.041,0,0,1-1.1,3.4v116.2l1.1,4.46-1.537,4.577"
            transform="translate(-14.636 -23.401)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_779"
            data-name="Path 779"
            d="M236.881,229.269H199.469s-3.624-.588-5.052,4.516l-1.428,5.1v13.369l-.783.783v89.244l1.113,1.19v12.593s1.1,11.128,3.954,11.055h39.609"
            transform="translate(-9.248 -19.695)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
      </g>

      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_rr_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="130"
          height="18"
          rx="9"
          transform="translate(445 600)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 600)"
        />
        <g class="arrow" id="Arrow">
          <path
            id="Path_412"
            data-name="Path 412"
            d="M6235.391,979.11l-62.667,16.969H6157"
            transform="translate(-5581.708 -386.533)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_127"
            data-name="Ellipse 127"
            cx="3"
            cy="3"
            r="3"
            transform="translate(650 589)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Indicator_Lamp-2"
          data-name="LFT RR Indicator Lamp"
          d="M196.907,233.6l1.635,4.481-1.1,3.4v8.676h-3.295V241.49S195.892,234.581,196.907,233.6Z"
          transform="translate(404.898 787.394) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Indicator_Lamp-3"
          data-name="LFT RR Indicator Lamp"
          transform="translate(450 612)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(559 612)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_cargo_deck'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rr_cargo_deck' | translate"
      >
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="116"
          height="18"
          rx="9"
          transform="translate(459 513)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 513)"
        />
        <circle
          id="Ellipse_130"
          data-name="Ellipse 130"
          cx="3"
          cy="3"
          r="3"
          transform="translate(675 528)"
          fill="#696969"
        />
        <path
          class="parts"
          id="RR_Cargo_Deck_2"
          data-name="RR Cargo Deck "
          d="M229.8,248.388v17.637l-1.867,1.867v79.62H229.8V365.3h81.926v3.477l19.987-2.85V247.383l-20.207-2.663v4.213Z"
          transform="translate(398.263 807.559) rotate(-90)"
          fill="#fff"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Path_410"
            data-name="Path 410"
            d="M6264.516,989.11l-86.307-9.453H6157"
            transform="translate(-5583.708 -458.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_244"
            data-name="Ellipse 244"
            cx="3"
            cy="3"
            r="3"
            transform="translate(678 528)"
            fill="#696969"
          />
        </g>
        <text
          id="RR_Cargo_Deck_3"
          data-name="RR Cargo Deck "
          transform="translate(481 525)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rr_cargo_deck' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(559 525)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['roll_over_bar'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.roll_over_bar' | translate"
      >
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(476 452)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 452)"
        />
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_406"
            data-name="Path 406"
            d="M6236.065,1012.11,6172.6,979.656H6157"
            transform="translate(-5581.708 -519.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_132"
            data-name="Ellipse 132"
            cx="3"
            cy="3"
            r="3"
            transform="translate(653 491)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="Roll_Over_Bar-2" data-name="Roll Over Bar">
          <path
            id="Path_785"
            data-name="Path 785"
            d="M459,247.849V369.074l4.535-.407V248.329Z"
            transform="translate(396.396 945.48) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_786"
            data-name="Path 786"
            d="M408.924,279.312h14.219v3.221H408.924l-9.811-1.017v-3.252Z"
            transform="translate(378.241 909.737) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_787"
            data-name="Path 787"
            d="M408.924,510h14.219v3.221H408.924l-9.811-1.017v-3.252Z"
            transform="translate(240.541 909.737) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Roll_Over_Bar-3"
          data-name="Roll Over Bar"
          transform="translate(492 464)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.roll_over_bar' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(559 464)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_panel'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="110"
          height="18"
          rx="9"
          transform="translate(465 542)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 542)"
        />
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_411"
            data-name="Path 411"
            d="M6214.082,979.656l-45.711,15.091h-11.106"
            transform="translate(-5581.708 -443.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_129"
            data-name="Ellipse 129"
            cx="3"
            cy="3"
            r="3"
            transform="translate(629 533)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Panel-2"
          data-name="LFT RR Panel"
          d="M303.034,222.8l83.445.512L382.69,219.5l-70.871-1.1Z"
          transform="translate(413.972 852.387) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Panel-3"
          data-name="LFT RR Panel"
          transform="translate(491 554)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(559 554)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['other_1'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.other_1' | translate"
        transform="translate(0 -3)"
      >
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="77"
          height="18"
          rx="9"
          transform="translate(498 631)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Other_1-2"
          data-name="Other 1"
          transform="translate(517 643)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.other_1' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 631)"
        />
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(559 643)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_panel'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="89"
          height="18"
          rx="9"
          transform="translate(665 639)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(736 639)"
        />
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_513"
            data-name="Path 513"
            d="M6158.215,3161v38.6"
            transform="translate(-5453 -2561)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_126"
            data-name="Ellipse 126"
            cx="3"
            cy="3"
            r="3"
            transform="translate(702 596)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RR_Panel-2"
          data-name="RR Panel"
          d="M177.524,319.1v64.665l2.874-3.041v-3.31l3.044-2.526V328.32l-3.5-3.075.541-3.931Z"
          transform="translate(353.869 777.471) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RR_Panel-3"
          data-name="RR Panel"
          transform="translate(685 651)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(738 651)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_stop_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="110"
          height="18"
          rx="9"
          transform="translate(465 571)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 571)"
        />
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <path
            id="Path_407"
            data-name="Path 407"
            d="M6244.39,989.656l-70.151-10H6157"
            transform="translate(-5581.39 -400.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_128"
            data-name="Ellipse 128"
            cx="3"
            cy="3"
            r="3"
            transform="translate(660 586)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Stop_Lamp-2"
          data-name="LFT Stop Lamp"
          d="M6124.145,3161.925h16v4.166h-10.394l-1.029-1.029h-4.579Z"
          transform="translate(-5469 -2572)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <text
          id="LFT_Stop_Lamp-3"
          data-name="LFT Stop Lamp"
          transform="translate(483 584)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_stop_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(559 583)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_emblem'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_rr_emblem' | translate"
      >
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="116"
          height="18"
          rx="9"
          transform="translate(459 482)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 482)"
        />
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <path
            id="Path_405"
            data-name="Path 405"
            d="M6221.456,1001.036l-51.708-21.38H6157"
            transform="translate(-5581.708 -489.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_131"
            data-name="Ellipse 131"
            cx="3"
            cy="3"
            r="3"
            transform="translate(638 509)"
            fill="#696969"
          />
        </g>
        <rect
          class="parts"
          id="LFT_RR_Emblem-2"
          data-name="LFT RR Emblem"
          width="15.529"
          height="2.556"
          rx="1.278"
          transform="translate(642.433 520.203) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Emblem-3"
          data-name="LFT RR Emblem"
          transform="translate(479 494)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_rr_emblem' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(559 494)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_fender'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_rr_fender' | translate"
      >
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="116"
          height="18"
          rx="9"
          transform="translate(459 421)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 421)"
        />
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_404"
            data-name="Path 404"
            d="M6217.8,990.746l-48.8-11.09H6157"
            transform="translate(-5581.198 -548.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_133"
            data-name="Ellipse 133"
            cx="3"
            cy="3"
            r="3"
            transform="translate(631 439)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Fender-2"
          data-name="LFT RR Fender"
          d="M682.979,223.88s.293-1.281-1.318-1.684-7.724-1.977-7.724-1.977H525.057s-.842.073-.805.659,0,1.94,0,1.94Z"
          transform="translate(412.888 984.431) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Fender-3"
          data-name="LFT RR Fender"
          transform="translate(485 433)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">LFT RR Fender</tspan>
        </text>
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(559 433)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rr_door'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_rr_door' | translate"
      >
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="102"
          height="18"
          rx="9"
          transform="translate(473 392)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 392)"
        />
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_403"
            data-name="Path 403"
            d="M6218.389,999.11l-49.279-19.454H6157"
            transform="translate(-5581.389 -579.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_134"
            data-name="Ellipse 134"
            cx="3"
            cy="3"
            r="3"
            transform="translate(634 417)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_RR_Door-2"
          data-name="LFT RR Door"
          d="M521.529,227.439s.879,15.4,1.831,16.788a4.64,4.64,0,0,0,4.393,2.211h58.882l2.416-19Z"
          transform="translate(408.578 982.806) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_RR_Door-3"
          data-name="LFT RR Door"
          transform="translate(494 404)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_rr_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(559 404)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_door'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_door' | translate"
      >
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="89"
          height="18"
          rx="9"
          transform="translate(486 361)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 361)"
        />
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_402"
            data-name="Path 402"
            d="M6219.988,989.11l-50.563-9.454H6157"
            transform="translate(-5583.39 -610.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_135"
            data-name="Ellipse 135"
            cx="3"
            cy="3"
            r="3"
            transform="translate(637 376)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Door-2"
          data-name="LFT Door"
          d="M683.039,246.438l2.416-19,88.278.75s1.117,4.027-4.979,6.059-32.873,11.476-44.843,11.476Z"
          transform="translate(408.578 1079.211) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Door-3"
          data-name="LFT Door"
          transform="translate(509 373)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(559 373)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_frt_fender'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_frt_fender' | translate"
      >
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="118"
          height="18"
          rx="9"
          transform="translate(457 303)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 303)"
        />
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_401"
            data-name="Path 401"
            d="M6218.711,974.248l-46.677,10.039H6157"
            transform="translate(-5581.999 -670.74)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_137"
            data-name="Ellipse 137"
            cx="3"
            cy="3"
            r="3"
            transform="translate(634 300)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_FRT_Fender-2"
          data-name="LFT FRT Fender"
          d="M903.578,228.134s8.9-1.428,11.147,3.24c0,0,2.452.275,3.313,1.428,0,0-.476-2.782,8.859-1.684l64.746,3.938-1.086-2.255-9.609-4.777s-2.471-6.973-5.766-7.687H917.306s-6.589,1.812-7.139,3.349l-4.722.11S905.775,227.091,903.578,228.134Z"
          transform="translate(412.817 1210.85) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_FRT_Fender-3"
          data-name="LFT FRT Fender"
          transform="translate(480 316)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_frt_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(559 315)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['glasses'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.wind_screen' | translate"
      >
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="109"
          height="18"
          rx="9"
          transform="translate(466 273)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 273)"
        />
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_400"
            data-name="Path 400"
            d="M6293.729,1023.11,6183.97,979.656H6157"
            transform="translate(-5581.999 -697.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_138"
            data-name="Ellipse 138"
            cx="3"
            cy="3"
            r="3"
            transform="translate(709 323)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Wind_Screen-2"
          data-name="Glasses"
          d="M854.228,247.849l-47.519,11.368s-6.369,2.087-4.832,7.029c0,0,2.233,9.262,2.233,43.086,0,13.229-.12,26.683-1.7,39.83-.289,2.392-1.369,6.386,1.009,8.125,2.856,2.086,50.408,13.309,50.408,13.309s10.005,2.908,11.921-34.889l.644-21.982s-.331-38.277-2.39-47.97c0,0-2.011-16.587-6.807-16.532A4.081,4.081,0,0,0,854.228,247.849Z"
          transform="translate(396.396 1150.001) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Wind_Screen-3"
          data-name="Glasses"
          transform="translate(494 285)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.wind_screen' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(559 285)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['hood'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.hood' | translate"
      >
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="68"
          height="18"
          rx="9"
          transform="translate(507 244)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 244)"
        />
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_399"
            data-name="Path 399"
            d="M6291,984.11l-107.567-4.453H6157"
            transform="translate(-5581.999 -727.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_139"
            data-name="Ellipse 139"
            cx="3"
            cy="3"
            r="3"
            transform="translate(706 254)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Hood-2"
          data-name="Hood"
          d="M1024.568,280.114s-4.306-16.32-11.543-29.447l-64.746-3.938s-8.932-1.171-8.859,1.684c0,0,9.152-3.215,9.152,60,0,0,1.244,53.846-9.152,59.849,0,0-1.061,2.05,12.666,1.391l59.376-1.391,13.654-31.336.549-28.513v-20.1Z"
          transform="translate(397.206 1232.232) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Hood-3"
          data-name="Hood"
          transform="translate(526 256)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.hood' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(559 256)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_head_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="113"
          height="18"
          rx="9"
          transform="translate(462 184)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 184)"
        />
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_397"
            data-name="Path 397"
            d="M6233,999.11l-61.008-19.453H6157"
            transform="translate(-5581.999 -788.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_141"
            data-name="Ellipse 141"
            cx="3"
            cy="3"
            r="3"
            transform="translate(648 208)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Head_Lamp-2"
          data-name="LFT Head Lamp"
          d="M1095.511,239.407l9.609,4.777s4.95,10.088,8.672,19.352c1.959,4.875,3.578,9.522,3.957,12.349l4.979,4.979s-.586-13.288-10.305-34.648C1112.423,246.216,1109.952,240.78,1095.511,239.407Z"
          transform="translate(401.435 1325.414) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Head_Lamp-3"
          data-name="LFT Head Lamp"
          transform="translate(480 196)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(559 196)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_indicator_lamp' | translate"
      >
        <g id="Group_106" data-name="Group 106" transform="translate(457.792 213)">
          <rect
            id="Rectangle_38-16"
            data-name="Rectangle 38"
            width="128"
            height="18"
            rx="9"
            transform="translate(-10.792)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 213)"
        />
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_398"
            data-name="Path 398"
            d="M6223,980.11l-52.981-.454H6157"
            transform="translate(-5581.999 -757.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_140"
            data-name="Ellipse 140"
            cx="3"
            cy="3"
            r="3"
            transform="translate(638 220)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="LFT_Indicator_lamp-5"
          data-name="LFT Indicator lamp"
          d="M1095.511,239.407l9.609,4.777h5.471S1106.685,240.451,1095.511,239.407Z"
          transform="translate(401.435 1325.414) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="LFT_Indicator_lamp-6"
          data-name="LFT Indicator lamp"
          transform="translate(466 225)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(559 225)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['logo'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.logo' | translate"
      >
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="71"
          height="18"
          rx="9"
          transform="translate(504 155)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 155)"
        />
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_396"
            data-name="Path 396"
            d="M6290,1021.11l-106.764-41.454H6157"
            transform="translate(-5581.999 -816.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_111"
            data-name="Ellipse 111"
            cx="3"
            cy="3"
            r="3"
            transform="translate(706 202)"
            fill="#696969"
          />
        </g>
        <ellipse
          class="parts"
          id="Logo-2"
          data-name="Logo"
          cx="2.231"
          cy="5.384"
          rx="2.231"
          ry="5.384"
          transform="translate(700.237 205.869) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(559 167)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="Logo-3"
          data-name="Logo"
          transform="translate(528 167)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.logo' | translate }}
          </tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_bumper'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rr_bumper' | translate"
      >
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(819 573)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 573)"
        />
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_514"
            data-name="Path 514"
            d="M6204,3157.438l13.933.534,60.044-17.689"
            transform="translate(-5459 -2557.165)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_125"
            data-name="Ellipse 125"
            cx="3"
            cy="3"
            r="3"
            transform="translate(742 597)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="RR_Bumper-2" data-name="RR Bumper">
          <path
            id="Path_781"
            data-name="Path 781"
            d="M187.366,230.1s-9.554-1.2-9.774,4.127v5.1l-.879,25.039,6.245,7.139V253.479l.783-.783V239.326s1.618-7.013,2.758-7.885l1.015-.977Z"
            transform="translate(407.061 776.986) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_780"
            data-name="Path 780"
            d="M183.443,465.4s-6.062,4.246-5.916,8.2,0,25.3,0,25.3.146,6.553,1.684,7.212,7.871.98,7.871.98-1.94-3.469-2.526-10.058V484.43l-1.113-1.19Z"
            transform="translate(266.543 777.471) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="RR_Bumper-3"
          data-name="RR Bumper"
          transform="translate(842 585)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rr_bumper' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(821 585)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['tires'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.tyres' | translate"
      >
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="76"
          height="18"
          rx="9"
          transform="translate(819 628)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Tyres-2"
          data-name="Tyres"
          transform="translate(842 640)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.tyres' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 628)"
        />
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(821 640)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_emblem'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_rr_emblem' | translate"
      >
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="125"
          height="18"
          rx="9"
          transform="translate(819 478)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 478)"
        />
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_413"
            data-name="Path 413"
            d="M6157,1051.385l41.917-71.728h10.3"
            transform="translate(-5389.999 -492.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_122"
            data-name="Ellipse 122"
            cx="3"
            cy="3"
            r="3"
            transform="translate(764 557)"
            fill="#696969"
          />
        </g>
        <rect
          class="parts"
          id="RHT_RR_Emblem-2"
          data-name="RHT RR Emblem"
          width="15.529"
          height="2.556"
          rx="1.278"
          transform="translate(765.433 572.203) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Emblem-3"
          data-name="RHT RR Emblem"
          transform="translate(842 490)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_rr_emblem' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(821 490)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['cabin_roof'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.cabin_roof' | translate"
      >
        <g id="Group_106-2" data-name="Group 106" transform="translate(818.784 417)">
          <rect
            id="Rectangle_38-21"
            data-name="Rectangle 38"
            width="99"
            height="18"
            rx="9"
            transform="translate(0.216)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 417)"
        />
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_389"
            data-name="Path 389"
            d="M6157,1002.769l94.9-23.113h23.322"
            transform="translate(-5455.999 -554.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_120"
            data-name="Ellipse 120"
            cx="3"
            cy="3"
            r="3"
            transform="translate(698 446)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="Cabin_Roof-2"
          data-name="Cabin Roof"
          d="M623.668,283.953s-1.929-.035-.335,5.8,1.887,41.127,1.887,41.127.031,31.12-1.7,39.83c-1.224,6.075.154,7.033.154,7.033l-110.393-1.928v.6h-11.2l-.137-91.144h11.339v.6Z"
          transform="translate(374.845 971.111) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="Cabin_Roof-3"
          data-name="Cabin Roof"
          transform="translate(842 430)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.cabin_roof' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(821 429)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_rr_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="131"
          height="18"
          rx="9"
          transform="translate(819 538)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 538)"
        />
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_393"
            data-name="Path 393"
            d="M6157,1021.656l47.049-42h11.562"
            transform="translate(-5396.389 -432.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_124"
            data-name="Ellipse 124"
            cx="3"
            cy="3"
            r="3"
            transform="translate(758 586)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_RR_Indicator_Lamp-2"
          data-name="RHT Indicator Lamp"
          d="M198.542,534.81l-1.977,5.968s-1.6-5.651-1.78-6.927l-.307-2.518-.33-8.458h3.624l-.329,7.475Z"
          transform="translate(232.233 787.394) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Indicator_Lamp-3"
          data-name="RHT Indicator Lamp"
          transform="translate(842 550)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_rr_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(821 550)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_door'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_door' | translate"
      >
        <g id="Group_106-3" data-name="Group 106" transform="translate(818.784 355)">
          <rect
            id="Rectangle_38-23"
            data-name="Rectangle 38"
            width="87"
            height="18"
            rx="9"
            transform="translate(0.216)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 355)"
        />
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_387"
            data-name="Path 387"
            d="M6157,989.11l47.048-9.453h11.563"
            transform="translate(-5396.39 -616.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_118"
            data-name="Ellipse 118"
            cx="3"
            cy="3"
            r="3"
            transform="translate(758 370)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Door-2"
          data-name="RHT Door"
          d="M683.039,526.012l2.416,19,88.278-.751s1.117-4.027-4.979-6.058-32.873-11.476-44.843-11.476Z"
          transform="translate(230.361 1079.211) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Door-3"
          data-name="RHT Door"
          transform="translate(842 368)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(821 367)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_frt_fender'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_frt_fender' | translate"
      >
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="120"
          height="18"
          rx="9"
          transform="translate(819 297)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 297)"
        />
        <g class="arrow" id="Arrow-22" data-name="Arrow">
          <path
            id="Path_385"
            data-name="Path 385"
            d="M6157,979.656l34.693,14.546h8.526"
            transform="translate(-5380.999 -688.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_115"
            data-name="Ellipse 115"
            cx="3"
            cy="3"
            r="3"
            transform="translate(773 288)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_FRT_Fender-2"
          data-name="RHT FRT Fender"
          d="M918.4,548.945a17.2,17.2,0,0,1-3.349,1.156,4.308,4.308,0,0,1-3.441,2.944l-7.394.586s2.269,2.27,1.537,4.1h4.631s5.93,3.661,8.95,3.661l56.228-.076s5.327-3.719,5.766-7.807l9.133-4.93L922.766,550S918.973,549.787,918.4,548.945Z"
          transform="translate(216.891 1211.229) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_FRT_Fender-3"
          data-name="RHT FRT Fender"
          transform="translate(842 310)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_frt_fender' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(821 309)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['protectives'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.wiper_blades' | translate"
      >
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(819 267)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 267)"
        />
        <g class="arrow" id="Arrow-23" data-name="Arrow">
          <path
            id="Path_384"
            data-name="Path 384"
            d="M6157,993.656l79.01-14h19.417"
            transform="translate(-5434.875 -703.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_116"
            data-name="Ellipse 116"
            cx="3"
            cy="3"
            r="3"
            transform="translate(721 287)"
            fill="#696969"
          />
        </g>
        <g class="parts" id="Protectives-2" data-name="Protectives">
          <path
            id="Path_726"
            data-name="Path 726"
            d="M939.4,303.545l1.044-27.309s0-3.587,2.929-3.075,1.757,5.93,1.757,5.93Z"
            transform="translate(381.317 1232.232) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_727"
            data-name="Path 727"
            d="M933.648,320.019l.769,37.668s1.712-13.953,1.538-22.513A58.411,58.411,0,0,0,933.648,320.019Z"
            transform="translate(353.317 1228.798) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_728"
            data-name="Path 728"
            d="M934.636,424.652l6.7-37.778s.586-2.2,2.929-.8,0,7.394,0,7.394Z"
            transform="translate(314.168 1229.388) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_729"
            data-name="Path 729"
            d="M927.743,449.593s-.957,34.4-6.01,36.9Z"
            transform="translate(275.975 1221.686) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <text
          id="Wiper_Blades-3"
          data-name="Protectives"
          transform="translate(842 280)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.wiper_blades' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(821 279)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_headlight'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_head_lamp' | translate"
      >
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="115"
          height="18"
          rx="9"
          transform="translate(819 208)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 208)"
        />
        <g class="arrow" id="Arrow-24" data-name="Arrow">
          <path
            id="Path_382"
            data-name="Path 382"
            d="M6157,979.656l46.734,2.547h11.485"
            transform="translate(-5396 -767.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_113"
            data-name="Ellipse 113"
            cx="3"
            cy="3"
            r="3"
            transform="translate(758 209)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Head_lamp-2"
          data-name="RHT Head lamp"
          d="M1118.3,459.988s-12.264,30.9-13.655,31.335l-9.133,4.93s14.149-1.513,16.912-6.809c0,0,9.5-20.292,10.305-34.648a4.511,4.511,0,0,0,.812-2.139Z"
          transform="translate(274.146 1325.414) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Head_lamp-3"
          data-name="RHT Head lamp"
          transform="translate(842 220)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_head_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(821 220)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_indicator_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_indicator_lamp' | translate"
      >
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="131"
          height="18"
          rx="9"
          transform="translate(819 236)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 236)"
        />
        <g class="arrow" id="Arrow-25" data-name="Arrow">
          <path
            id="Path_383"
            data-name="Path 383"
            d="M6157,979.656l38.538,15.546h9.471"
            transform="translate(-5385.789 -748.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_114"
            data-name="Ellipse 114"
            cx="3"
            cy="3"
            r="3"
            transform="translate(767 227)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_Indicator_lamp-5"
          data-name="RHT Indicator lamp"
          d="M1095.511,553.509l9.133-4.93h6.178S1107.756,551.969,1095.511,553.509Z"
          transform="translate(216.891 1325.414) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_Indicator_lamp-6"
          data-name="RHT Indicator lamp"
          transform="translate(842 249)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_indicator_lamp' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(821 248)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_grill'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.frt_grill' | translate"
      >
        <rect
          id="Rectangle_38-28"
          data-name="Rectangle 38"
          width="95"
          height="18"
          rx="9"
          transform="translate(819 148)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-28"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 148)"
        />
        <g class="arrow" id="Arrow-26" data-name="Arrow">
          <path
            id="Path_380"
            data-name="Path 380"
            d="M6157,1026.11l78.845-46.454h19.375"
            transform="translate(-5436 -824.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_110"
            data-name="Ellipse 110"
            cx="3"
            cy="3"
            r="3"
            transform="translate(718 199)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Grill-2"
          data-name="FRT Grill"
          d="M1153.4,356.147v35.582s3.441-3.4,3.88-5.82v-7.174s1.279-1.276,1.279-4.867c0,0,.112-3.105-1.279-4.867v-7.655S1155.747,356.293,1153.4,356.147Z"
          transform="translate(331.753 1359.97) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Grill-3"
          data-name="FRT Grill"
          transform="translate(842 161)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.frt_grill' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-28"
          data-name="3.0"
          transform="translate(821 160)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_bumper'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.frt_bumper' | translate"
      >
        <rect
          id="Rectangle_38-29"
          data-name="Rectangle 38"
          width="99"
          height="18"
          rx="9"
          transform="translate(819 177)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-29"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 177)"
        />
        <g class="arrow" id="Arrow-27" data-name="Arrow">
          <path
            id="Path_381"
            data-name="Path 381"
            d="M6157,995.11l54.762-15.453h13.458"
            transform="translate(-5406 -794.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_112"
            data-name="Ellipse 112"
            cx="3"
            cy="3"
            r="3"
            transform="translate(749 198)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="FRT_Bumper-2"
          data-name="FRT Bumper"
          d="M1104.819,225.267s-7.907-6.15-23.612-5.107c0,0,5.491,3.459,5.766,7.687,0,0,13.288.934,16.912,6.809,0,0,9.353,19.493,10.305,34.648,0,0,1.025,1.354,2.05,8.42v29.8c-1.025,7.065-2.05,8.42-2.05,8.42-.952,15.156-10.305,34.648-10.305,34.648-3.624,5.876-16.912,6.809-16.912,6.809-.275,4.228-5.766,7.687-5.766,7.687,15.7,1.043,23.612-5.107,23.612-5.107,14.386-11.2,16.253-67.36,16.253-67.36S1119.205,236.469,1104.819,225.267Z"
          transform="translate(412.994 1316.876) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="FRT_Bumper-3"
          data-name="FRT Bumper"
          transform="translate(842 189)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.frt_bumper' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-29"
          data-name="3.0"
          transform="translate(821 189)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_panel'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_rr_panel' | translate"
      >
        <rect
          id="Rectangle_38-30"
          data-name="Rectangle 38"
          width="115"
          height="18"
          rx="9"
          transform="translate(819 447)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-30"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 447)"
        />
        <g class="arrow" id="Arrow-28" data-name="Arrow">
          <path
            id="Path_512"
            data-name="Path 512"
            d="M6157,1028.656l32.274-49h7.932"
            transform="translate(-5377.985 -523.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_121"
            data-name="Ellipse 121"
            cx="3"
            cy="3"
            r="3"
            transform="translate(775 505)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_RR_Panel-2"
          data-name="RHT RR Panel"
          d="M303.034,570.523l83.445-.513-3.789,3.807-70.871,1.1Z"
          transform="translate(206.098 848.479) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Panel-3"
          data-name="RHT RR Panel"
          transform="translate(842 460)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_rr_panel' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-30"
          data-name="3.0"
          transform="translate(821 459)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rr_door'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_rr_door' | translate"
      >
        <rect
          id="Rectangle_38-31"
          data-name="Rectangle 38"
          width="103"
          height="18"
          rx="9"
          transform="translate(819 386)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-31"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 386)"
        />
        <g class="arrow" id="Arrow-29" data-name="Arrow">
          <path
            id="Path_388"
            data-name="Path 388"
            d="M6157,1007.914l47.047-28.258h11.563"
            transform="translate(-5396.389 -586.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_119"
            data-name="Ellipse 119"
            cx="3"
            cy="3"
            r="3"
            transform="translate(758 419)"
            fill="#696969"
          />
        </g>
        <path
          class="parts"
          id="RHT_RR_Door-2"
          data-name="RHT RR Door"
          d="M521.529,545.011s.879-15.4,1.831-16.788a4.64,4.64,0,0,1,4.393-2.211h58.882l2.416,19Z"
          transform="translate(230.361 982.806) rotate(-90)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <text
          id="RHT_RR_Door-3"
          data-name="RHT RR Door"
          transform="translate(842 399)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_rr_door' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-31"
          data-name="3.0"
          transform="translate(821 398)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_rv_mirror'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-32"
          data-name="Rectangle 38"
          width="106"
          height="18"
          rx="9"
          transform="translate(819 326)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-32"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 326)"
        />
        <g class="parts" id="RHT_R.V_Mirror-2" data-name="RHT R.V Mirror">
          <path
            id="Path_734"
            data-name="Path 734"
            d="M858.481,559.795s-.22,2.7,0,2.694l6.04-.022,3.362-2.672Z"
            transform="translate(210.196 1183.873) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_735"
            data-name="Path 735"
            d="M844.626,567.031,837.1,581.143a6.129,6.129,0,0,0,5.82-.439c2.8-1.922,8.786-10.506,8.786-10.506s1.483-2.939-.6-3.767h-5.326A.974.974,0,0,0,844.626,567.031Z"
            transform="translate(206.254 1171.171) rotate(-90)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g class="arrow" id="Arrow-30" data-name="Arrow">
          <path
            id="Path_458"
            data-name="Path 458"
            d="M6206.991,979.656h-20.38l-7.625-6.224"
            transform="translate(-5390.198 -644.201)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_117"
            data-name="Ellipse 117"
            cx="3"
            cy="3"
            r="3"
            transform="translate(785 326)"
            fill="#696969"
          />
        </g>
        <text
          id="RHT_R.V_Mirror-3"
          data-name="RHT R.V Mirror"
          transform="translate(842 339)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-32"
          data-name="3.0"
          transform="translate(821 338)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['lft_rv_mirror'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.lft_r_v_mirror' | translate"
      >
        <rect
          id="Rectangle_38-33"
          data-name="Rectangle 38"
          width="107"
          height="18"
          rx="9"
          transform="translate(468 333)"
          fill="#242e3a"
          opacity="0.07"
        />
        <circle
          id="Ellipse_21-33"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(557 333)"
        />
        <g class="parts" id="LFT_R.V_Mirror-2" data-name="LFT R.V Mirror">
          <path
            id="Path_754"
            data-name="Path 754"
            d="M858.481,236.8s-.22-2.7,0-2.695l6.04.023,3.362,2.672Z"
            transform="translate(404.601 1183.873) rotate(-90)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_755"
            data-name="Path 755"
            d="M844.626,210.911,837.1,196.8a6.129,6.129,0,0,1,5.82.439c2.8,1.922,8.786,10.506,8.786,10.506s1.483,2.939-.6,3.766h-5.326A.973.973,0,0,1,844.626,210.911Z"
            transform="translate(427.193 1171.171) rotate(-90)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <g class="arrow" id="Arrow-31" data-name="Arrow">
          <path
            id="Path_386"
            data-name="Path 386"
            d="M6203.661,969.33l-37.286,10.326H6157"
            transform="translate(-5581.533 -636.11)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_136"
            data-name="Ellipse 136"
            cx="3"
            cy="3"
            r="3"
            transform="translate(620 329)"
            fill="#696969"
          />
        </g>
        <text
          id="LFT_R.V_Mirror-3"
          data-name="LFT R.V Mirror"
          transform="translate(485 346)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.lft_r_v_mirror' | translate }}
          </tspan>
        </text>
        <text
          id="_3.0-33"
          data-name="3.0"
          transform="translate(559 345)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rht_stop_lamp'] || ''"
        [attr.data-name]="'exterior.pickup_double_cabin.rht_stop_lamp' | translate"
      >
        <rect
          id="Rectangle_38-34"
          data-name="Rectangle 38"
          width="117"
          height="18"
          rx="9"
          transform="translate(819 509)"
          fill="#242e3a"
          opacity="0.07"
        />
        <path
          class="parts"
          id="RHT_Stop_lamp-2"
          data-name="RHT Stop lamp"
          d="M6140.146,3161.925h-16v4.166h10.394l1.029-1.029h4.579Z"
          transform="translate(-5385 -2572)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <circle
          id="Ellipse_21-34"
          data-name="Ellipse 21"
          cx="9"
          cy="9"
          r="11"
          transform="translate(819 509)"
        />
        <g class="arrow" id="Arrow-32" data-name="Arrow">
          <path
            id="Path_392"
            data-name="Path 392"
            d="M6159.165,1050.9l58.44-66.98,7.613-4.264"
            transform="translate(-5405.999 -461.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_123"
            data-name="Ellipse 123"
            cx="3"
            cy="3"
            r="3"
            transform="translate(749 587)"
            fill="#696969"
          />
        </g>
        <text
          id="_3.0-34"
          data-name="3.0"
          transform="translate(821 521)"
          fill="#030303"
          font-size="7.5"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <text
          id="RHT_Stop_lamp-3"
          data-name="RHT Stop lamp"
          transform="translate(842 521)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'exterior.pickup_double_cabin.rht_stop_lamp' | translate }}
          </tspan>
        </text>
      </g>
    </g>
  </svg>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : {{ 'exterior.qc_passed' | translate }}
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : {{ 'exterior.qc_failed' | translate }}
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>

    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part change)</option>
                <option [value]="2">2 (Major Repair)</option>
                <option [value]="3">3 (Moderate Repair)</option>
                <option [value]="4">4 (Minor Repair)</option>
                <option [value]="5">5 (Good part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <!-- <label class="modal_car_input_label">Description</label> -->
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                [readonly]="role !== 'admin'"
                mask="separator.5"
                thousandSeparator=""
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                [readonly]="role !== 'admin'"
                mask="separator.5"
                thousandSeparator=""
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="
            !vehicleStatus &&
            ((editableRole.includes(role) && role !== 'estimator') ||
              ['qc', 'evaluator'].includes(role))
          "
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn-primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
